// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"7911c63b","806":"201aee9d"}[chunkId] + ".chunk.js";
};